/** Sections with their own report list (Jamie, 04/11/26: each report in the section it's about). Shop and Fuel open on their sales. */
export const SECTIONS = ["shop", "fuel", "dashboard", "tasks", "cash", "maintenance", "compliance", "audits", "people", "settings"];
const SALES_HOME = new Set(["shop", "fuel"]);
export function whereNow(path = typeof window === "undefined" ? "" : window.location.pathname) {
    const m = /^\/reports\/([a-z]+)(\/|$)/.exec(path);
    return m && SECTIONS.includes(m[1]) ? m[1] : "reports";
}
/** Each section's report home: Shop's and Fuel's sales drill-down, the others their list (Reports: the full list). */
export const HOME = Object.fromEntries([["reports", "/reports"], ...SECTIONS.map((w) => [w, `/reports/${w}`])]);
/** Where one report opens. */
export const viewPath = (w) => (w === "reports" ? "/reports/view" : `${HOME[w]}/view`);
/** The sales drill-down's address (only Shop and Fuel have their own). */
export const drillPath = (w) => (SALES_HOME.has(w) ? HOME[w] : "/reports/sales");
/** What the back link says. */
export const BACK = Object.fromEntries([["reports", "All reports"], ["shop", "Shop sales"], ["fuel", "Fuel sold"], ...SECTIONS.filter((w) => !SALES_HOME.has(w)).map((w) => [w, "Reports"])]);
/** A link a report or the server made (/reports/view?…, /reports/sales?…), kept in the section it's opened in. */
export function localise(href, w) {
    if (w === "reports")
        return href;
    const out = href.replace(/^\/reports\/view(?=[?#]|$)/, viewPath(w));
    return SALES_HOME.has(w) ? out.replace(/^\/reports\/sales(?=[?#]|$)/, drillPath(w)) : out;
}
/** The reports each section lists under its sales (the rest stay in Reports). */
// The car wash and machine takings (Nayax, SNAP, Ready2Wash) sit with Shop, as the car wash pages do since #145.
export const SHOP_CATEGORIES = ["Sales", "Costs & margin", "Products & pricing", "Waste", "Concessions & machines"];
export const FUEL_REPORTS = ["fuel_breakdown"];
/** Which section's list each report is in (by category, or by the report for the operational ones). */
const BY_ID = { trading: "dashboard", task_completion: "tasks", site_checks: "tasks", projects: "tasks", maintenance: "maintenance", audit_scores: "audits" };
const BY_CATEGORY = { "Cash office": "cash", People: "people", Training: "people", Data: "settings" };
export function sectionOf(r) {
    if (BY_ID[r.id])
        return BY_ID[r.id];
    if (FUEL_REPORTS.includes(r.id))
        return "fuel";
    if (SHOP_CATEGORIES.includes(r.category))
        return "shop";
    return BY_CATEGORY[r.category] ?? "reports";
}
export function belongsTo(w, r) {
    return w === "reports" || sectionOf(r) === w;
}
